// src/Pages/Education/EditEducation.jsx

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/features/modalSlice';
import { useUpdateEducationMutation } from '../../redux/services/educationService/education.Services';
import { successToast, errorToast } from '../../Utils/toast';

function EditEducation({ data }) {
  const dispatch = useDispatch();
  const [updateEducation, { isLoading }] = useUpdateEducationMutation();
  
  const [formData, setFormData] = useState({
    id: '',
    education_name: '',
    status: 'active',
  });

  useEffect(() => {
    if (data) {
      setFormData({
        id: data.id || '',
        education_name: data.education_name || data.name || '',
        status: data.status || 'active',
      });
    }
  }, [data]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.education_name.trim()) {
      errorToast('Education name is required');
      return;
    }

    try {
      const payload = {
        id: formData.id,
        education_name: formData.education_name,
        status: formData.status,
      };

      const response = await updateEducation(payload).unwrap();
      successToast(response?.message || 'Education updated successfully');
      dispatch(closeModal());
    } catch (error) {
      console.error('Update error:', error);
      errorToast(error?.data?.message || 'Failed to update education');
    }
  };

  return (
    <div className="edit-education-container">
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label fw-bold">
            Education Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="education_name"
            value={formData.education_name}
            onChange={handleChange}
            placeholder="Enter education name"
            required
            autoFocus
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Status</label>
          <select
            className="form-control"
            name="status"
            value={formData.status}
            onChange={handleChange}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        <div className="d-flex justify-content-end gap-2 mt-4">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => dispatch(closeModal())}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Saving...
              </>
            ) : (
              'Save Changes'
            )}
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditEducation;